import { useState } from 'react';
import LabOrderCard from './LabOrderCard'

const LabOrders = ({ orders, onDelete, onUpdateOrder, isAdmin }) => {
  const [openMenuId, setOpenMenuId] = useState(null);

  if (!orders?.length) {
    return (
      <div className="main-cards-container lab-orders-empty-state" role="status">
        Not found
      </div>
    )
  }

  return (
    <div className="main-cards-container">
      <div className="w-layout-grid sub-container-cards lab-orders-grid">
        {orders?.map((order) => (
          <LabOrderCard key={order.id} order={order} onDelete={onDelete} isAdmin={isAdmin} setOpenMenuId={setOpenMenuId} openMenuId={openMenuId} onUpdateOrder={onUpdateOrder} />
        ))}
      </div>
    </div>
  )
}

export default LabOrders
